import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { MenuManagementExecutionService } from '@/services/Execution/MenuManagementExecutionService';

export const useMenuManagementDeleteExecution = async (
  id: string
): Promise<void> => {
  const menuManagementExecutionService = new MenuManagementExecutionService(
    getClient()
  );

  return menuManagementExecutionService
    .delete(id)
    .catch((error: Error) => errorHandler({ error }));
};
